export const getters = {
  productRecommendationMap: (state) => state.productRecommendationMap,
  filterByPriceGroup: (state) => state.filterByPriceGroup,
  optimizerLanguage: (state) => state.optimizerLanguage,
  indexedProductPrices: (state) => state.indexedProductPrices,
  useOneService: (state) => state.useOneService
};
